import React from 'react'
import classNames from 'classnames'

interface Props {
	keypadEnabled: boolean
	qrEnabled: boolean
	searchEnabled: boolean
	className?: string
}

const ScannerIcon: React.FC<Props> = ({ keypadEnabled, qrEnabled, searchEnabled, className }) => {
	let icon = 'fak fa-scan-and-find'
	if (keypadEnabled && !qrEnabled && !searchEnabled) icon = 'fak fa-dialpad'
	else if (!keypadEnabled && !qrEnabled && searchEnabled) icon = 'fal fa-magnifying-glass'

	return (
		<i
			className={classNames('tab-icon', icon, className)}
		></i>
	)
}

export default ScannerIcon
